module.exports = __webpack_public_path__ + "img/1f630.2c0f1d4.svg";